<template>
  <div class="common-space-between container">
    <list ref="indexList" v-if="isIf"></list>
    <div v-if="!isIf" style="width: 100%;">
      <deail v-if="!isIf" :operate="operate" :edits="edits"></deail>
    </div>
  </div>
</template>

<script>
import list from './common-module/block_index_list.vue'
import deail from './common-module/block-deail.vue'


export default {
  name: 'index',
  components:{
      list,
      deail
  },
  data:()=>({
    edits:{},
    index:'',         // 用于判断在处于什么操作
    isIf:true
  }),
  created(){
    this.$off('setEdits');
    this.$off("setIsIf")
    this.$bus.$on('setIsIf',res=>{
      this.setIsIf(res);
    })
    this.$bus.$on("setEdits",res=>{
      this.edits = res;
    })
  },
  methods:{
    setIsIf(isIf){
      this.index = "";
      this.isIf = isIf;
      if(isIf){
        this.$nextTick(()=>{
          this.$refs.indexList.init();
          
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 .warp-btn{
       display: flex;
       justify-content: flex-start;
    }
    .right-div{
       height: 300px;
       border-radius: 4px;
       padding: 15px;
       box-sizing: border-box;
       .warp-table{
           padding-top: 10px;
       }
    }
  ::v-deep .el-dialog__header{
    height: 23px;
    background: #F8F9FA;
    box-shadow: 0px 1px 0px 0px rgb(237 238 240);
    border-radius: 12px 12px 0 0;
   }
   ::v-deep .el-dialog{
    border-radius: 12px;
   }
</style>